import React, { ElementType, ReactNode } from 'react'
import {
  StepLabel as MUIStepLabel,
  StepIconProps,
  SxProps
} from '@mui/material'

interface StepLabelProps {
  children?: ReactNode
  StepIconComponent?: ElementType<StepIconProps> | undefined
  StepIconProps?: object
  sx?: SxProps
}

const StepLabel = React.forwardRef((props: StepLabelProps, ref: any) => {
  return (
    <MUIStepLabel {...props} ref={ref}>
      {props.children}
    </MUIStepLabel>
  )
})

StepLabel.displayName = 'StepLabel'
export default StepLabel
